<div class="toolbar-share">
  <button class="toolbar-share-button" (click)="onButtonClick()">
    <span class="toolbar-share-button__icon icon-check"></span>
    <ng-container i18n>Download or share</ng-container>
  </button>

  <app-popup *ngIf="popupIsDisplayed" [(display)]="popupIsDisplayed">
    <app-share></app-share>
  </app-popup>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/components/toolbar/toolbar-share/toolbar-share.component.html